export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "support_access_token";
export const MAX_TICKET_ATTACHMENTS = 10;
export const MAX_ATTACHMENT_SIZE = 5 * 1024 * 1024;

export const initialLogin = {
  email: "",
  password: "",
};

export const initialAdminClient = {
  id: "",
  full_name: "",
  email: "",
  password: "",
  managed_developer_id: "",
  tma_enabled: false,
  tma_visible_to_client: false,
  tma_package_label: "TMA Juin 2026",
  tma_minutes_total: "",
  tma_new_package_label: "",
  tma_new_package_minutes: "",
  tma_new_packages: [],
};

export const initialAdminDeveloper = {
  id: "",
  full_name: "",
  email: "",
  password: "",
  can_access_platform: true,
};

export const initialForgotPassword = {
  email: "",
};

export const initialResetPassword = {
  token: "",
  new_password: "",
  confirm_password: "",
};

export const initialTicket = {
  client_id: "",
  developer_id: "",
  send_notifications: false,
  title: "",
  category: "modification-contenu",
  site_url: "",
  description: "",
};

export const STATUS_OPTIONS = [
  { value: "ticket_ouvert", label: "Ticket ouvert" },
  { value: "en_cours_de_traitement", label: "En cours de traitement" },
  { value: "traite", label: "Traite" },
  { value: "demande_info_supplementaires", label: "Demande d'informations supplementaires" },
];

export const DELETABLE_TICKET_STATUSES = ["ticket_ouvert", "en_cours_de_traitement"];
